import { FC } from 'react'
import { Box, Popover, Typography } from '@mui/material'

interface Props {
  anchorEl: HTMLElement | null
  onClose: () => void
  caseQuantity?: number | null
  palletQuantity?: number | null
}

const ProductQuantityModal: FC<Props> = ({
  anchorEl,
  onClose,
  caseQuantity,
  palletQuantity,
}) => {
  const open = Boolean(anchorEl)

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      slotProps={{
        paper: {
          sx: {
            width: 171,
            boxShadow: '0px 16px 26px rgba(5, 19, 80, 0.07)',
            border: '1px solid #d1d9f0',
            backgroundColor: '#222f3e',
            padding: '12px 16px',
            display: 'flex',
            flexDirection: 'column',
            gap: '6px',
          },
        },
      }}
    >
      {palletQuantity && palletQuantity > 0 ? (
        <Box>
          <Typography
            sx={{
              fontSize: 14,
              fontFamily: 'Roboto',
              color: '#d6dff7',
            }}
          >
            {palletQuantity} / PALLET
          </Typography>
        </Box>
      ) : (
        ''
      )}
      {caseQuantity && caseQuantity > 0 ? (
        <Box>
          <Typography
            sx={{
              fontSize: 14,
              fontFamily: 'Roboto',
              color: '#d6dff7',
            }}
          >
            {caseQuantity} / CASE
          </Typography>
        </Box>
      ) : (
        ''
      )}
    </Popover>
  )
}

export default ProductQuantityModal
